import { MatxLoadable } from "matx";
import { isMdScreen } from "utils";

const HomeRaft = MatxLoadable({
    loader: () => import("./HomeRaft")
  });

  const Redirect = MatxLoadable({
    loader: () => import("./Redirect")
  });

const Form = MatxLoadable({
    loader: () => import("./Form")
  });

const CalendarForm = MatxLoadable({
    loader: () => import("./forms/FormAdminCalendar")
  });

const Calendar = MatxLoadable({
    loader: () => import("./tables/adminCalendarTable")
  });

const VideoForm = MatxLoadable({
    loader: () => import("./forms/videoRaftForm")
  });

const RaftTable = MatxLoadable({
    loader: () => import("./tables/adminRaftTable")
  });

const BannersRaft = MatxLoadable({
    loader: () => import("./forms/bannersSettingsRaft")
  });

  const settings = {
    activeLayout: "layout1",
    layout1Settings: {
      topbar: {
        show: true
      },
      leftSidebar: {
        show: true,
        mode: isMdScreen() ? "close" : "full"
      }
    },
    likeDislikeButtons: { show: false }
  };

  const RafRoutes = [
    {
      path: "/BAF/RegionalBAF",
      component: Redirect,
      settings
    },
    {
      path: "/BAF/Home",
      component: HomeRaft,
      settings
    },
    {
      path: "/BAF/form",
      component: Form,
      settings
    },
    {
      path: "/BAF/Calendar/CalendarForm/:id",
      component: CalendarForm,
      settings
    },
    {
      path: "/BAF/Calendar/CalendarForm",
      component: CalendarForm,
      settings
    },
    {
      path: "/BAF/Calendar",
      component: Calendar,
      settings
    },
    {
      path: "/BAF/Video",
      component: VideoForm,
      settings
    },
    {
      path: "/BAF/Banners",
      component: BannersRaft,
      settings
    },
    {
      path: "/BAF/MyReferrals",
      component: RaftTable,
      settings
    },
  ];
  
  export default RafRoutes;